<template>
  <v-container
    fluid
    class="pa-0 ma-0 d-flex flex-column justify-center align-center"
  >
    <v-img
      src="@/assets/images/header_image.svg"
      class="fluid-max-width-login my-2 my-md-6"
      width="100%"
    />
    <v-container class="fluid-max-width-login pa-6 text-center" v-if="!token">
      <validation-observer ref="requestObserver" v-slot="{ invalid }">
        <p>
          Geben Sie nachfolgend die E-Mail-Adresse Ihres Benutzers ein, dann
          schicken wir Ihnen per E-Mail Anweisungen zum Zurücksetzen Ihres
          Passworts zu.
        </p>
        <form @submit.prevent="request">
          <validation-provider
            v-slot="{ errors }"
            name="email"
            rules="required|email"
            mode="lazy"
          >
            <v-text-field
              v-model="email"
              :error-messages="errors"
              label="E-Mail"
              name="email"
              type="email"
              autocomplete="username email"
              required
              single-line
              prepend-inner-icon="mdi-account"
            ></v-text-field>
          </validation-provider>
          <v-btn
            color="primary"
            class="mt-6"
            width="200"
            type="submit"
            :disabled="invalid"
            :loading="isSubmitting"
            depressed
          >
            Passwort zurücksetzen
          </v-btn>
          <p v-if="isSubmitted" class="mt-4 primary--text">
            Wir haben Ihnen eine E-Mail mit Anweisungen zum Zurücksetzen Ihres
            Passworts gesendet.
          </p>
        </form>
      </validation-observer>
    </v-container>
    <v-container class="fluid-max-width-login pa-6 text-center" v-else>
      <validation-observer ref="resetObserver" v-slot="{ invalid }">
        <p>
          Geben Sie nachfolgend Ihr gewünschtes Passwort ein:
        </p>
        <form @submit.prevent="reset">
          <validation-provider
            v-slot="{ errors }"
            name="password"
            vid="password"
            rules="required"
            lazy
          >
            <v-text-field
              v-model="password"
              :error-messages="errors"
              label="Passwort"
              name="password"
              type="password"
              required
              single-line
              prepend-inner-icon="mdi-lock"
            ></v-text-field>
          </validation-provider>
          <validation-provider
            v-slot="{ errors }"
            name="confirmPassword"
            rules="required|passwordsMatch:@password"
            lazy
          >
            <v-text-field
              v-model="confirmPassword"
              :error-messages="errors"
              label="Passwort wiederholen"
              name="confirmPassword"
              type="password"
              required
              single-line
              prepend-inner-icon="mdi-lock"
            ></v-text-field>
          </validation-provider>
          <v-btn
            color="primary"
            class="mt-6"
            width="200"
            type="submit"
            :disabled="invalid"
            depressed
          >
            Passwort setzen
          </v-btn>
          <p v-if="isSubmitted" class="mt-4 primary--text">
            Das Passwort wurde erfolgreich geändert, wir leiten Sie in wenigen
            Momenten zum Login weiter.
          </p>
          <p v-if="isError" class="mt-4">
            Das hat leider nicht geklappt. Stellen Sie sicher, dass Sie den Link
            aus dem E-Mail geklickt haben und die Anforderung nicht länger als
            24 Stunden zurückliegt.
            <router-link to="/passwort-reset">
              Neue E-Mail anfordern...
            </router-link>
          </p>
        </form>
      </validation-observer>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Login',
  components: {},
  data: () => ({
    email: '',
    password: '',
    confirmPassword: '',
    token: undefined,
    invalid: false,
    isSubmitting: false,
    isSubmitted: false,
    isError: false,
  }),
  watch: {
    $route() {
      if (!this.$route.query.token) {
        this.isSubmitting = false;
        this.isSubmitted = false;
        this.token = undefined;
        this.password = undefined;
      }
    },
  },
  created() {
    if (this.$route.query.token) {
      this.token = this.$route.query.token;
    }
  },
  methods: {
    ...mapActions(['requestPasswordReset', 'resetPassword']),
    async request() {
      this.isSubmitting = true;
      var success = await this.requestPasswordReset({
        email: this.email,
      });
      if (success) {
        this.isSubmitted = true;
        this.email = undefined;
        this.$refs.requestObserver.reset();
      }
      this.isSubmitting = false;
    },
    async reset() {
      this.isSubmitting = true;
      var success = await this.resetPassword({
        password: this.password,
        token: this.token,
      });
      if (success) {
        this.isSubmitting = false;
        this.isSubmitted = true;
        setTimeout(() => {
          this.$router.push('/login');
        }, 3000);
      } else this.isError = true;
      this.isSubmitting = false;
    },
  },
};
</script>

<style scoped>
.fluid-max-width-login {
  max-width: 500px;
}
</style>
